import { render } from "./EditSize.vue?vue&type=template&id=2dd85f16"
import script from "./EditSize.vue?vue&type=script&lang=js"
export * from "./EditSize.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__